import PropTypes from 'prop-types'
import { useState, useEffect, useCallback } from 'react'
import { useLocation, matchPath } from 'react-router-dom'
// @mui
import { Collapse } from '@mui/material'
// hooks
import useActiveLink from '../../../hooks/useActiveLink'
//
import NavItem from './NavItem'
import Can from '../../can'

// ----------------------------------------------------------------------

NavList.propTypes = {
  data: PropTypes.object,
  depth: PropTypes.number,
  hasChild: PropTypes.bool,
}

export default function NavList({ data, depth, hasChild }) {
  const { pathname } = useLocation()

  const { active, isExternalLink } = useActiveLink(data.path)

  const isDescendantActive = (item) => {
    if (item.children) {
      return item.children.some((child) => {
        if (child.path && child.path !== '#') {
          return !!matchPath({ path: child.path, end: false }, pathname)
        }
        if (child.children) {
          return isDescendantActive(child)
        }
        return false
      })
    }
    return false
  }

  const anyChildActive = isDescendantActive(data)

  const [open, setOpen] = useState(active || anyChildActive)

  useEffect(() => {
    if (!active && !anyChildActive) {
      handleClose()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleToggle = useCallback((item) => {
    if (item.action) {
      item.action()
    }
    setOpen((prev) => !prev)
  }, [])

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <NavItem
        item={data}
        depth={depth}
        open={open}
        active={active}
        isExternalLink={isExternalLink}
        onClick={() => handleToggle(data)}
      />

      {hasChild && (
        <Collapse in={open} unmountOnExit>
          <NavSubList data={data.children} depth={depth} />
        </Collapse>
      )}
    </>
  )
}

// ----------------------------------------------------------------------

NavSubList.propTypes = {
  data: PropTypes.array,
  depth: PropTypes.number,
}

function NavSubList({ data, depth }) {
  return (
    <>
      {data.map((list) => (
        <Can key={list.permission} perform={list.permission}>
          <NavList
            key={list.title + list.path}
            data={list}
            depth={depth + 1}
            hasChild={!!list.children}
          />
        </Can>
      ))}
    </>
  )
}
